<template>
  <div id="app" style="padding-bottom: 3%;">
    <div>
    <img class="license" src="@/assets/images/index/yyzz.png" alt="" />
  </div>
  </div>
</template>
<style lang="less" scoped>
.license{
  width: 100%;
  margin-top: 75px;
}
</style>